import ArticleIcon from "@mui/icons-material/Article";
import { IconButton } from "@mui/material";
import WindowService from "../../../services/windowService";

export const AgreementPassportButton = (props) => {
    const { agreement } = props;
    const typeKey = agreement.agreement_type?.agretype_key;
    const targetAgreementId =
        typeKey && typeKey !== "Agreement"
            ? (agreement.agreement_parent ?? agreement.id)
            : agreement.id;

    const handleOpenPassportDialogInNewTab = () => {
        WindowService.openInNewTab(`/agreements/passport/${targetAgreementId}/`);
    };

    return (
        <IconButton color="primary" onClick={() => handleOpenPassportDialogInNewTab()}>
            <ArticleIcon />
        </IconButton>
    );
};
